<script lang="ts" setup>
import { onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { useNotificationsStore } from '@/store/notifications'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const notifications = useNotificationsStore()
const { t } = useI18n()

onBeforeMount(() => {
  notifications.addNotification({
    title: 'Error',
    text: t('layouts.pageNotFound'),
    type: 'error',
    time: 10000
  })
  void router.push({ name: 'Dashboard' })
})
</script>

<template>
  <div>
    <h1>Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
  </div>
</template>
